<div [formGroup]="form" class="grid">
  <mat-form-field>
    <mat-label>{{ 'CONTROLS.date_from_label' | translate: { label: label || '' } }}</mat-label>
    <input [matDatepicker]="dateFromPicker" [max]="form.value.toDatetime" formControlName="fromDatetime" matInput>
    <mat-datepicker-toggle [for]="dateFromPicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #dateFromPicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'CONTROLS.date_to_label' | translate: { label: label || '' } }}</mat-label>
    <input [matDatepicker]="dateToPicker" [min]="form.value.fromDatetime" formControlName="toDatetime" matInput>
    <mat-datepicker-toggle [for]="dateToPicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #dateToPicker></mat-datepicker>
  </mat-form-field>
</div>
